import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const MoneyBagOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="m19.45 13.74-4-6.38 1.1-1.89c.6-1.03.01-2.48-1.01-2.48H8.49c-1.03 0-1.62 1.47-1 2.49l1.15 1.93-3.96 6.32c-2.02 3.21.47 7.26 4.46 7.26h5.85c3.99 0 6.48-4.04 4.46-7.26v.01ZM15.19 4.6s0 .05-.02.07l-1.35 2.31h-3.58L8.86 4.67s-.02-.05-.02-.07h6.35Zm2.99 13.02c-.62 1.12-1.81 1.79-3.19 1.79H9.14c-1.38 0-2.57-.67-3.19-1.79-.54-.97-.5-2.07.09-3.02L9.8 8.61h4.55l3.76 5.99c.59.95.63 2.05.09 3.02h-.02Z" />
      <Path d="M9.58 12.2h1.55c.56 0 .98.26 1.11.73H9.58v.68h2.65c-.15.45-.57.74-1.1.74H9.58v1.04h1.1l1.5 2.52h1.36l-1.65-2.65c.74-.12 1.45-.67 1.58-1.65h.96v-.68h-.97c-.08-.43-.31-.82-.68-1.09h1.65v-.68H9.58v1.04Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default MoneyBagOutlined
